module.exports = __webpack_public_path__ + "static/media/twitter.083230ea.png";